import { ContentBox } from 'app/agriculture/components/ContentBox/ContentBox';
import { Button } from 'app/agriculture/components/Button/Button';
import { useContext } from 'react';
import { DeviceDetailContext } from 'app/agriculture/routes/Devices/DeviceDetails/context/DeviceDetailContextProvider';
import './WeatherStationContent.scss';
import { WeatherDisplaySkeleton } from 'app/agriculture/routes/Devices/DeviceDetails/components/display/WeatherDisplaySkeleton';
import { useFarmPath } from 'app/agriculture/router/useFarmPath';
import { useNavigate } from 'react-router-dom';

export function WeatherStationContentSkeleton() {
    const { device } = useContext(DeviceDetailContext);
    const navigate = useNavigate();
    const farmPath = useFarmPath();
    return (
        <ContentBox.Section className="WeatherStationContent" heading="Weather Data">
            <WeatherDisplaySkeleton />
            <Button
                className="WeatherStationContent__button"
                onClick={() => {
                    navigate(farmPath('/weather-dashboard'), {
                        state: { initialWeatherStationId: device.id },
                    });
                }}
                variant="outlined"
                text="Weather Dashboard"
                endIcon="goto"
            />
        </ContentBox.Section>
    );
}
